module.exports = __webpack_public_path__ + "images/nico_villeneve_640.jpg";